import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { NamedLink, ReviewRating, IconButtonArrow, IconQuotes, AvatarLarge } from '../../components';
import { createSlug } from '../../util/urlHelpers';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';

import { fetchReviews } from './FeaturedReviews.duck';

import css from './FeaturedReviews.module.css';

const FeaturedReviewsComponent = props => {
  const { className, rootClassName, onFetchReviews, featuredReviews } = props;

  useEffect(() => {
    onFetchReviews();
  }, [])

  if (!featuredReviews?.length) return null;

  return (
    <div className={css.root}>
      <div className={css.reviewsHolder}>
        {featuredReviews.map((r, i) => {

          return (
            <div className={css.review} key={`review-${r?.rating}-${i}`}>

              <div className={css.reviewAuthor}>
                <AvatarLarge className={css.reviewAuthorImg} user={r?.author} disableProfileLink />

                <span className={css.reviewAuthorName}>
                  {r?.author?.attributes?.profile?.displayName}
                </span>

                <IconQuotes className={css.reviewQuotes} />
              </div>

              <ReviewRating
                rating={r?.rating}
                className={css.reviewRating}
                reviewStarClassName={css.reviewRatingStar}
              />

              <p className={css.reviewText}>
                {r?.review}
              </p>

              {r?.listingId && r?.listingTitle && (
                <NamedLink
                  name='ListingPage'
                  params={{
                    id: r.listingId,
                    slug: createSlug(r.listingTitle)
                  }}
                  className={css.reviewLink}
                >
                  VIEW WORKSHOP
                  <IconButtonArrow />
                </NamedLink>
              )}

            </div>
          )
        })}
      </div>
    </div>
  );
};


const mapStateToProps = state => {
  const { currentUser } = state.user;
  const { reviews } = state.FeaturedReviews;

  const reviewsData = reviews?.map(t => {
    return getMarketplaceEntities(state, t ? [t] : []);
  })?.flat() || [];

  const featuredReviews = reviewsData?.map(r => {

    const listing = r.listing;
    const review = r?.reviews?.find?.(r => r.attributes.type === "ofProvider")

    if (!review) return

    return {
      author: review.author,
      rating: review.attributes.rating,
      review: review.attributes.content,
      listingId: listing.id.uuid,
      listingTitle: listing.attributes.title
    }
  })?.filter(r => !!r)?.slice(0,3);

  return {
    currentUser,
    featuredReviews
  };
};

const mapDispatchToProps = dispatch => ({
  onFetchReviews: params => dispatch(fetchReviews(params)),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const FeaturedReviews = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(FeaturedReviewsComponent);

export default FeaturedReviews;
